import { useCallback, useEffect, useState } from "react";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import Button from "../../../atoms/Button";
import Heading from "../../../atoms/Heading";
import InputField from "../../../atoms/InputField";
import HipotecaSection from "../../../molecules/inmueblesCreate/HipotecaSection";
import { initialValuesInmueble } from "../../../molecules/inmueblesCreate/formSchemaInmueble";
import { validationSchemaHipoteca } from "./formSchemaHipoteca";
import { UPDATE_INMUEBLE } from "../../../../api/apiInmuebles";
import { DELETE_HIPOTECA, GET_HIPOTECA, REGISTER_HIPOTECA } from "../../../../api/apiFiles";

const HipotecaEdit = ({ inmueble, refetch, onClose }) => {
    const { id } = useParams();
    const [generatedCode, setGeneratedCode] = useState("");
    const [hipoteca, setHipoteca] = useState();
    const [archivosHipoteca, setArchivosHipoteca] = useState({
        compra_venta: null,
        amortizacion: null,
    });

    useEffect(() => {
        if (inmueble.isRented) {
            const newCode = Math.random().toString(36).substring(2, 8).toUpperCase();
            setGeneratedCode(newCode);
        }
    }, [inmueble.isRented]);

    const getHipoteca = useCallback( async () => {
        try {
            const hipotecaData = await GET_HIPOTECA(inmueble.id);
            setHipoteca(hipotecaData);
        } catch (error) {
            toast.error("Error al obtener la información");
            onClose();
        };
    }, [inmueble, onClose]);

    useEffect(() => {
        getHipoteca();
    }, [getHipoteca]);

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            setSubmitting(true);
            if (values.isMortgaged) {
                await REGISTER_HIPOTECA(inmueble.id, archivosHipoteca, values);
                await UPDATE_INMUEBLE(inmueble.id, { isMortgaged: true})
            } else if (!values.isMortgaged) {
                if (values.code === generatedCode) {
                    await DELETE_HIPOTECA(hipoteca.id);
                    await UPDATE_INMUEBLE(inmueble.id, { isMortgaged: false})
                } else {
                    toast.error("El código ingresado no es válido.");
                    return;
                }
            }
            refetch();
            onClose();
            toast.success("Inmueble actualizado correctament");
        } catch (error) {
            toast.error("Error al actualizar el inmueble")
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div>
            <Heading
                text={ inmueble.isMortgaged ?
                    "Confirme para eliminar la hipoteca"
                    :
                    "Active y complete los campos para hipotecar"
                }
            />
            <Formik
                onSubmit={handleSubmit}
                validationSchema={validationSchemaHipoteca}
                initialValues={{ ...initialValuesInmueble, real_estate: Number(id), code:"" }}
            >
                {({ values, isSubmitting, setFieldValue }) => (
                    <Form className="flex flex-col justify-center items-center gap-5">
                        {!inmueble.isMortgaged &&
                            <HipotecaSection values={values} setFieldValue={setFieldValue} setArchivosHipoteca={setArchivosHipoteca} />
                        }
                        {inmueble.isMortgaged && !values.isMortgaged &&
                            <div className="w-full flex flex-col space-y-4 justify-center items-center">
                                <div className="w-1/2 bg-gray-300 rounded-lg p-4 select-none text-center"
                                    onContextMenu={(e) => e.preventDefault()}
                                    onCopy={(e) => e.preventDefault()}
                                    onCut={(e) => e.preventDefault()}
                                    onPaste={(e) => e.preventDefault()}
                                    >
                                    <p className="font-bold tracking-widest text-lg">{generatedCode}</p>
                                </div>
                                <InputField name="code" label="Código de confirmación" placeholder="Ingresa el código" value={values.code} />
                            </div>
                        }
                        <Button text={isSubmitting ? <PropagateLoader color="red" /> : "Agregar"} type="submit" bgColor="blue" disabled={isSubmitting}/>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default HipotecaEdit;